import { create } from 'zustand'
import { operations } from '@/lib/types/api-types.ts'

export type InvitedOrganization =
  operations['api_organizations_idinvited_organizations_get_collection']['responses']['200']['content']['application/ld+json']
export type InvitingOrganization =
  operations['api_organizations_idinviting_organizations_get_collection']['responses']['200']['content']['application/ld+json']

type OrganizationStore = {
  invitedOrganizations: InvitedOrganization | null
  setInvitedOrganizations: (organizations: InvitedOrganization | null) => void
  invitingOrganizations: InvitedOrganization | null
  setInvitingOrganizations: (organizations: InvitedOrganization | null) => void
}

export const useOrganizationStore = create<OrganizationStore>(set => ({
  invitedOrganizations: null,
  setInvitedOrganizations: (organizations: InvitedOrganization | null) => {
    set({ invitedOrganizations: organizations })
  },
  invitingOrganizations: null,
  setInvitingOrganizations: (organizations: InvitingOrganization | null) => {
    set({ invitingOrganizations: organizations })
  },
}))
